import classNames from 'classnames';
import React, {useLayoutEffect, useRef, useState} from 'react';

import {LeafIcon} from '../../../resources/Icons';
import Row from '../../common/Row';
import {SupplierTag} from '../marketplace/types';
import Tag from './Tag';

type Props = {
  tags: SupplierTag[];
  expanded: boolean;
  className?: string;
};

const Tags = ({tags, expanded, className}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [hidden, setHidden] = useState<boolean[]>();

  useLayoutEffect(() => {
    if (!expanded) {
      if (hidden) return;
      const container = containerRef.current;
      if (container) {
        const newHidden = new Array(tags.length).fill(false);
        let i = 0;
        const limit = container.getBoundingClientRect().right;
        for (const child of container.children) {
          if (child instanceof HTMLElement) {
            if (child.classList.contains('hiddenCounter')) continue;

            const right = child.getBoundingClientRect().right;
            if (newHidden.some(Boolean) || right > limit) {
              newHidden[i] = true;
            }
            i++;
          }
        }
        setHidden(newHidden);
      }
    } else {
      if (containerRef.current) {
        for (const child of containerRef.current.children) {
          if (child instanceof HTMLElement) {
            child.classList.remove('hidden');
          }
        }
      }
      setHidden(undefined);
    }
  }, [expanded, hidden, tags]);

  const hiddenCount = hidden?.filter(Boolean).length;

  return (
    <Row ref={containerRef} className={classNames('items-center gap-3', expanded && 'flex-wrap', className)}>
      {tags.map((tag, idx) => (
        <Tag
          key={idx}
          className={classNames('relative', hidden?.[idx] && 'hidden', tag.type === 'crop' && 'pl-[2.8rem]')}
        >
          {tag.type === 'crop' && (
            <LeafIcon
              className={'absolute left-[1.2rem] top-1/2 -translate-y-1/2 w-[1.2rem]'}
              role="img"
              aria-label="crop"
            />
          )}
          {tag.tag}
        </Tag>
      ))}
      {!expanded && !!hiddenCount && <div className={'hiddenCounter text-2xs'}>+{hiddenCount}</div>}
    </Row>
  );
};

export default Tags;
